/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { color, pxToEm, centerAbsolutely, imageTypes, animations, backgrounds } from 'utils/styles';
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// ANSWER ERROR STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
    uniquecontent: {
        width: '100%',
        height: '100%',
    	'& .contentindicator, .pointindicator': {
    		display: 'none'
    	},
    	'& .frame.type-answererror': {
    		position: 'relative'
    	},
    	'& .background': {
    		'& .fade': {
    			background: `${backgrounds.standout} !important`
    		}
	    },
    	'& .answererror': {
	    	textAlign: 'center',
	        width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
	    }
    }
};